
define('unknown/views/registerView',[
	'jquery',
	'underscore',
	'backbone',
	'unknown/models/registerModel',
	
	//Shims
	'jquery.sha256'
], function($, _, Backbone, RegisterModel){
	var RegisterFooterView = Backbone.View.extend({
		events: {
			'click #registerFormSubmit': 'submitRegisterForm'
		},
		
		initialize: function(options) {
			this.showForm();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.showForm);
			this.listenTo(this.event, 'saving', this.showNonForm);
			this.listenTo(this.event, 'error', this.showForm);
			this.listenTo(this.event, 'success', this.showNonForm);
		},
		
		submitRegisterForm: function () {
			this.event.trigger("save");
		},
		
		showForm: function () {
			this.$("#registerFormSubmit").show();
		},
		
		showNonForm: function () {
			this.$("#registerFormSubmit").hide();
		},
	});

	var RegisterContentView = Backbone.View.extend({	
		initialize: function(options) {
			this.hideAll();
			
			this.registerModel = options.registerModel;
			this.event = options.event;
			this.submittedData = options.submittedData;
			
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			_.bindAll(this, 'formEnter');
			
			$('#regBodyContentForm').on("keyup", this.formEnter);
			
			this.listenTo(this.event, 'save', this.submitRegistration);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'default', this.form);
			this.listenTo(this.event, 'error', this.form);
			this.listenTo(this.event, 'success', this.success);
			
			//Error handling
			this.listenTo(this.event, 'error:username', this.errorUsername);
			this.listenTo(this.event, 'error:password', this.errorPassword);
			this.listenTo(this.event, 'error:email', this.errorEmail);
		},
		
		submitRegistration: function () {
			if(!this.submittedData.isSubmitted){
				this.event.trigger("saving");
				
				//Attempt to register user
				var submittable = false;
				var username = this.$("#registerUserNameInput").val();
				var email = this.$("#registerEmailInput").val();
				
				if(this.$("#registerPasswordInput").val()){
					if(this.$("#registerPasswordInput").val() == username){
						this.event.trigger("error");
						this.event.trigger("error:password", "SAME");
					} else if (this.$("#registerPasswordInput").val().length < 5) {
						this.event.trigger("error");
						this.event.trigger("error:password", "LENGTH");
					} else {
						submittable = true;
					} 
				} else {
					submittable = true;
				}
									
				if(submittable){
					this.submittedData.isSubmitted = true;
					this.registerModel.save({
						userName: username,
						password : this.$("#registerPasswordInput").val() ? $.sha256(this.$("#registerPasswordInput").val()) : "",
						email: email
					},{wait: true,
						success : this.successCallback, 
						error : this.errorCallback
					});	
				}
			}
		},
		
		successCallback: function(model, response) {
			this.event.trigger("savingSuccess", model, response);
		},
		
		errorCallback: function(model, error) {
			this.event.trigger("savingError", model, error);
		},
		
		formEnter: function(e) {
			var code = e.keyCode || e.which; 
			if (code  == 13) {               
				e.preventDefault();
				this.event.trigger("save");
				return false;
			}
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			this.$("#regBodyContentForm").hide();
			this.$("#regBodyContentProcessing").hide();
			this.$("#regBodyContentSuccess").hide();
			
			//Hide error messages
			this.$("#registerUserNameGrp").removeClass("error");
			this.$("#registerUserNameInput").removeClass("error");
			this.$("#regUserNameErrMsg").hide();
			
			this.$("#registerPasswordGrp").removeClass("error");
			this.$("#registerPasswordInput").removeClass("error");
			this.$("#regPasswordErrMsg").hide();
			
			this.$("#registerEmailGrp").removeClass("error");
			this.$("#registerEmailInput").removeClass("error");
			this.$("#regEmailErrMsg").hide();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#regBodyContentSuccess").show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#regBodyContentProcessing").show();
		},
		
		form: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#regBodyContentForm").show();
		},
		
		errorUsername : function (errorCode) {
			this.$("#registerUserNameGrp").addClass("error");
			this.$("#registerUserNameInput").addClass("error");
			
			switch (errorCode){
				case "NULL": 
					this.$("#regUserNameErrMsg").html("Username is empty");
					this.$("#regUserNameErrMsg").show();
					break;
				case "LENGTH": 
					this.$("#regUserNameErrMsg").html("Username must be between 5 and 20 characters long");
					this.$("#regUserNameErrMsg").show();
					break;
				case "ALPHANUM": 
					this.$("#regUserNameErrMsg").html("Username may only contain alpha numeric characters");
					this.$("#regUserNameErrMsg").show();
					break;
				case "USEREXISTS": 
					this.$("#regUserNameErrMsg").html("User has already been created");
					this.$("#regUserNameErrMsg").show();
					break;
				default : 
					this.$("#regUserNameErrMsg").html("Username is invalid");
			}
		},
		
		errorPassword : function (errorCode) {
			this.$("#registerPasswordGrp").addClass("error");
			this.$("#registerPasswordInput").addClass("error");
			
			switch (errorCode){
				case "NULL": 
					this.$("#regPasswordErrMsg").html("Password is empty");
					this.$("#regPasswordErrMsg").show();
					break;
				case "LENGTH": 
					this.$("#regPasswordErrMsg").html("Password must be at least 5 characters long");
					this.$("#regPasswordErrMsg").show();
					break;
				case "SAME": 
					this.$("#regPasswordErrMsg").html("Password must not match the user name");
					this.$("#regPasswordErrMsg").show();
					break;
				default : 
					this.$("#regPasswordErrMsg").html("Password is invalid");
			}
		},
		
		errorEmail : function (errorCode) {
			this.$("#registerEmailGrp").addClass("error");
			this.$("#registerEmailInput").addClass("error");
			
			switch (errorCode){
				case "NULL": 
					this.$("#regEmailErrMsg").html("Email is empty");
					this.$("#regEmailErrMsg").show();
					break;
				case "EMAIL": 
					this.$("#regEmailErrMsg").html("Invalid email address");
					this.$("#regEmailErrMsg").show();
					break;
				case "NOTEQUAL":
					this.$("#regEmailErrMsg").html("Email must match the confirmatin email address");
					this.$("#regEmailErrMsg").show();
					break;
				case "EMAILEXISTS":
					this.$("#regEmailErrMsg").html("Email has already been registered");
					this.$("#regEmailErrMsg").show();
					break;
				default : 
					this.$("#regEmailErrMsg").html("Invalid email address");
			}
		}
	});

	var RegisterMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.hideAll();
			
			this.event = options.event;
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'success', this.success);
		},
		
		hideAll: function() {
			$(this.el).hide();
			this.$("#regBodyMessageError").hide();
			this.$("#regBodyMessageProcessing").hide();
			this.$("#regBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#regBodyMessageError").show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#regBodyMessageSuccess").show();
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			this.$("#regBodyMessageProcessing").show();
		},
	});
	
	var RegisterView = Backbone.View.extend({
		el: $("#regContent"),
		
		initialize: function(options) {
			this.registerModel = options.registerModel;
			this.event = _.extend({}, Backbone.Events);
			this.submittedData = {isSubmitted : false};
			
			this.message = new RegisterMessageView({el: this.$("#regBodyMessage"), event: this.event});
			this.content = new RegisterContentView({
				el: this.$("#regBodyContent"), 
				event: this.event, 
				registerModel: this.registerModel,
				submittedData: this.submittedData});
			this.footer = new RegisterFooterView({el: this.$("#regFooter"), event: this.event});
			
			this.listenTo(this.event, 'savingSuccess', this.registered);
			this.listenTo(this.event, 'savingError', this.registerError);
		},
		
		render: function () {
			this.event.trigger("default");
			return this;
		},
		
		registerError: function(model, error) {
			if(this.submittedData.isSubmitted){
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else if (error.status == 409) {
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);			
					if(errObj.message && errObj.message.toLowerCase().indexOf("email") > -1){
						//Email already activated
						this.event.trigger("error:email", "EMAILEXISTS");
					} else if(errObj.message && errObj.message.toLowerCase().indexOf("user") > -1) {
						//User already activated
						this.event.trigger("error:username", "USEREXISTS");
					}
				} else {
					this.event.trigger("error");
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		registered: function () {
			this.submittedData.isSubmitted = false;
			window.location.href = "/draftapp/dashboard";
			//Event.trigger("success");
		},
	});
	
	return RegisterView;  
});